import * as signalR from '@microsoft/signalr';
import { getAccessToken } from './api';

const HUB_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5243/api').replace(/\/api$/, '');

/**
 * Singleton qui gère UNE SEULE connexion SignalR pour toute l'app.
 * Plusieurs hooks peuvent s'y abonner via on() sans créer de connexions multiples.
 */
class SignalRService {
  constructor() {
    this._connection = null;
    // Liste des [event, callback] à ré-attacher si la connexion est recréée
    this._subscriptions = [];
  }

  async start() {
    if (
      this._connection?.state === signalR.HubConnectionState.Connected ||
      this._connection?.state === signalR.HubConnectionState.Connecting ||
      this._connection?.state === signalR.HubConnectionState.Reconnecting
    ) return;

    this._connection = new signalR.HubConnectionBuilder()
      .withUrl(`${HUB_URL}/notificationHub`, {
        // Appelé à chaque reconnexion → token toujours frais
        accessTokenFactory: () => getAccessToken(),
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Warning)
      .build();

    // Ré-attacher tous les abonnements enregistrés avant le start()
    this._subscriptions.forEach(([event, cb]) => this._connection.on(event, cb));

    await this._connection.start().catch(() => {/* SignalR indispo — polling en secours */});
  }

  async stop() {
    if (this._connection) {
      await this._connection.stop().catch(() => {});
      this._connection = null;
    }
  }

  /**
   * S'abonne à un événement. Retourne une fonction de désabonnement.
   * Peut être appelé avant start() — l'abonnement est mémorisé et ré-attaché.
   */
  on(event, callback) {
    this._subscriptions.push([event, callback]);
    if (this._connection) this._connection.on(event, callback);

    return () => {
      this._subscriptions = this._subscriptions.filter(
        ([e, cb]) => !(e === event && cb === callback)
      );
      if (this._connection) this._connection.off(event, callback);
    };
  }
}

export const signalRService = new SignalRService();
